module.exports = __webpack_public_path__ + "img/selectedMbeansBg.5e646abb.svg";